import { ApiError } from '@/services/api/client'

export function schemaErrorMessage(error: unknown, fallback: string): string {
  if (!(error instanceof ApiError)) return fallback
  const data: unknown = error.data
  if (!data || typeof data !== 'object' || !('detail' in data)) return fallback
  const detail = data.detail
  if (typeof detail === 'string') return detail
  if (Array.isArray(detail)) {
    const messages = detail.flatMap((item: unknown) => {
      if (!item || typeof item !== 'object' || !('msg' in item) || typeof item.msg !== 'string')
        return []
      const location =
        'loc' in item && Array.isArray(item.loc)
          ? item.loc.filter(part => part !== 'body').join(' › ')
          : ''
      return [`${location ? `${location}: ` : ''}${item.msg}`]
    })
    return messages.join('\n') || fallback
  }
  if (
    detail &&
    typeof detail === 'object' &&
    'message' in detail &&
    typeof detail.message === 'string'
  )
    return detail.message
  return fallback
}
